module.exports = __webpack_public_path__ + "media/assets/ecmc-8b4b038fd3f324b809628b2857a81f86.png";